import { ERRORS, ERRORS_MESSAGE } from '../../constants';

export const getInfoByError = (error, isEmptyAccount) => {
  const errorDesc = {
    code: null,
    titleKey: null,
    subTitleKey: null,
  };

  if (isEmptyAccount) {
    errorDesc.code = ERRORS.NO_POSTS;
    errorDesc.titleKey = 'widget.empty.editor.p1';
    errorDesc.subTitleKey = 'widget.empty.editor.p2';
    return errorDesc;
  }

  errorDesc.code = error.code;
  if (typeof error.message === 'object') error = error.message;
  if (error.message) {
    error.message = error.message.split('+').join(' ');
    if (
      error.message.indexOf(
        'Error validating access token: Session has expired on',
      ) !== -1
    ) {
      error.message =
        'Error validating access token: Session has expired on...';
    }
  }

  switch (error.code) {
    case ERRORS.OLD_API:
      errorDesc.titleKey = 'widget.error.oldApi.content';
      errorDesc.subTitleKey = 'widget.error.oldApi.reconnect';
      break;
    case ERRORS.INVALID_TOKEN:
    case ERRORS.INVALID_TOKEN_2:
    case ERRORS.INVALID_TOKEN_3:
      errorDesc.titleKey = 'widget.error.invalidToken.invalidAuth.title';
      errorDesc.subTitleKey = 'widget.error.invalidToken.invalidAuth.desc';

      if (error.message) {
        if (error.message.includes(ERRORS_MESSAGE.PASSWORD_CHANGED)) {
          errorDesc.titleKey =
            'widget.error.invalidToken.passwordChanged.title';
          errorDesc.subTitleKey =
            'widget.error.invalidToken.passwordChanged.desc';
        } else if (error.message.includes(ERRORS_MESSAGE.SESSION_EXPIRED)) {
          errorDesc.titleKey = 'widget.error.invalidToken.sessionExpired.title';
          errorDesc.subTitleKey =
            'widget.error.invalidToken.sessionExpired.desc';
        } else if (error.message.includes(ERRORS_MESSAGE.NOT_CONFIRMED_USER)) {
          errorDesc.titleKey =
            'widget.error.invalidToken.notConfirmedUser.title';
          errorDesc.subTitleKey =
            'widget.error.invalidToken.notConfirmedUser.desc';
        } else if (error.message.includes(ERRORS_MESSAGE.NOT_AUTHORIZED_APP)) {
          errorDesc.titleKey =
            'widget.error.invalidToken.notAuthorizedApp.title';
          errorDesc.subTitleKey =
            'widget.error.invalidToken.notAuthorizedApp.desc';
        } else if (error.message.includes(ERRORS_MESSAGE.NO_PERMISSION)) {
          errorDesc.titleKey = 'widget.error.invalidToken.notPermission.title';
          errorDesc.subTitleKey =
            'widget.error.invalidToken.notPermission.desc';
        } else if (error.message.includes(ERRORS_MESSAGE.INVALID_AUTH)) {
          errorDesc.titleKey = 'widget.error.invalidToken.invalidAuth.title';
          errorDesc.subTitleKey = 'widget.error.invalidToken.invalidAuth.desc';
        }
      }
      break;
    case ERRORS.NO_POSTS:
      errorDesc.titleKey = 'widget.empty.editor.p1';
      errorDesc.subTitleKey = 'widget.empty.editor.p2';
      break;
    default:
      errorDesc.titleKey = 'widget.error.connectInsta.content.1';
      errorDesc.subTitleKey = 'widget.error.connectInsta.content.2';
      break;
  }

  console.log({ errorDesc });
  return errorDesc;
};
